angular.
module("dx.webapp.exam").
constant("DX_TEXT_TO_SPEECH_SETTING", Object.freeze({
	TextToSpeechSettingAllowOverride: 0,
	TextToSpeechSettingAllowAll: 1,
	TextToSpeechSettingDenyAll: 2,
}));
